import Login from "../Screens/Auth/Login";
import Otp from "../Screens/Auth/Otp";
import Registration from "../Screens/Auth/Registration";
import ResetPasswordPage from "../Screens/Auth/ResetPassword";
import Verification from "../Screens/Auth/Verification";
import PublicAuth from "./PublicAuth";

export const PublicRoutes = () => {
  return [
    {
      element: <PublicAuth />,
      children: [
        {
          path: "/register",
          element: <Registration />,
        },
        {
          path: "/verification",
          element: <Verification />,
        },
        {
          path: "/reset-password",
          element: <ResetPasswordPage />,
        },
        {
          path: "/",
          element: <Login />,
        },
        {
          path: "/otp",
          element: <Otp />,
        },
      ],
    },
  ];
};
